import React from "react";
import { CheckIcon } from "@chakra-ui/icons";

export const CheckLine = (props) => {
  return <CheckIcon {...props} />;
};
